import { render, staticRenderFns } from "./BienvenidaIcon.vue?vue&type=template&id=4b7a2644&"
import script from "./BienvenidaIcon.vue?vue&type=script&lang=js&"
export * from "./BienvenidaIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports